
export class Pregunta {
    preguntaid: number = 0;
    clave: number = 0;
    competenciaid: number = 0;
    criterioid: number = 0;
    tipopreguntaid: number = 0;
    escalaevaluacionid: number = 0;
    nivelid: number[] = [];
    pregunta: string = "";
    mostrarautoevaluacion: boolean = false;
    autoevaluacion: string = "";
    activo: boolean = true;
    relacionado: boolean = false;
    departamentobloqueado: boolean = false;

    constructor(init?: Partial<Pregunta>) {
        Object.assign(this, init);
    }
}
